import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SheetSlotComponentBase } from 'src/app/services/sheets-renderer.service';
import { MedicationActionV3 } from 'src/app/types/sheet-action-aggregate-graph.types';
import { TickValueComponent } from '../../tick-value/tick-value.component';

@Component({
    selector: 'app-medication-slot-v3',
    templateUrl: './medication-slot-v3.component.html',
    styleUrl: './medication-slot-v3.component.scss',
    imports: [TickValueComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MedicationSlotComponentV3 implements SheetSlotComponentBase {

	action!: MedicationActionV3;
	value!: string | null;

	@Input('action') set updateAction(action: MedicationActionV3 | null) {
		this.action = action as MedicationActionV3;
		this.value = this.action.dose?.quantity?.toString() ?? null;
	}

	constructor() {
	}
}